"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.default = void 0;

require("core-js/modules/es6.object.freeze");

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _argumentContracts = _interopRequireDefault(require("argument-contracts"));

/**
 *  A single selected point item
 *
 * @param {object} options Object containing all options (SEE BELOW)
 * @param {number} options.seriesIndex The position of the series in the series array.
 * @param {number} options.key The position of the category value on the X Axis array
 *
 * @property {string} seriesIndex
 * @property {string} key
 */
var SelectedPoint =
/*#__PURE__*/
function () {
  function SelectedPoint(_ref) {
    var seriesIndex = _ref.seriesIndex,
        key = _ref.key;
    (0, _classCallCheck2.default)(this, SelectedPoint);

    _argumentContracts.default.assertNumber(seriesIndex, 'options.seriesIndex');

    _argumentContracts.default.assertNumber(key, 'options.key');

    this.seriesIndex = seriesIndex;
    this.key = key;
    Object.freeze(this);
  }

  (0, _createClass2.default)(SelectedPoint, [{
    key: "serialize",
    value: function serialize() {
      return "".concat(this.seriesIndex, ":::").concat(this.key);
    }
  }]);
  return SelectedPoint;
}();

exports.default = SelectedPoint;